var map = {
	"./de": 1755,
	"./de.json": 1755,
	"./en": 1756,
	"./en.json": 1756,
	"./es": 1757,
	"./es.json": 1757,
	"./fr": 1758,
	"./fr.json": 1758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1754;